module.exports = __webpack_public_path__ + "img/model2.eb89f9d6.png";